import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const SearchQuestionsItemsDocument = `
    query SearchQuestionsItems($request: QuestionSearchRequestInput!) {
  searchQuestions(request: $request) {
    items {
      status
      accessibleType
      attachments {
        blindType
        id
      }
      category {
        name
        id
        iconImagePath
      }
      tags {
        name
      }
      createdAt
      content
      isBlockedByMe
      publicId
      title
      userMaskedName
      userId
    }
  }
}
    `;
export const useSearchQuestionsItemsQuery = <
      TData = Types.SearchQuestionsItemsQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchQuestionsItemsQueryVariables,
      options?: UseQueryOptions<Types.SearchQuestionsItemsQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchQuestionsItemsQuery, TError, TData>(
      ['SearchQuestionsItems', variables],
      gqlFetcher<Types.SearchQuestionsItemsQuery, Types.SearchQuestionsItemsQueryVariables>(SearchQuestionsItemsDocument, 'SearchQuestionsItems', variables),
      options
    );

useSearchQuestionsItemsQuery.getKey = (variables: Types.SearchQuestionsItemsQueryVariables) => ['SearchQuestionsItems', variables];
;

useSearchQuestionsItemsQuery.fetcher = (variables: Types.SearchQuestionsItemsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchQuestionsItemsQuery, Types.SearchQuestionsItemsQueryVariables>(SearchQuestionsItemsDocument, 'SearchQuestionsItems', variables, options);
export const SearchQuestionsTotalCountDocument = `
    query SearchQuestionsTotalCount($request: QuestionSearchRequestInput!) {
  searchQuestions(request: $request) {
    totalCount
  }
}
    `;
export const useSearchQuestionsTotalCountQuery = <
      TData = Types.SearchQuestionsTotalCountQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchQuestionsTotalCountQueryVariables,
      options?: UseQueryOptions<Types.SearchQuestionsTotalCountQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchQuestionsTotalCountQuery, TError, TData>(
      ['SearchQuestionsTotalCount', variables],
      gqlFetcher<Types.SearchQuestionsTotalCountQuery, Types.SearchQuestionsTotalCountQueryVariables>(SearchQuestionsTotalCountDocument, 'SearchQuestionsTotalCount', variables),
      options
    );

useSearchQuestionsTotalCountQuery.getKey = (variables: Types.SearchQuestionsTotalCountQueryVariables) => ['SearchQuestionsTotalCount', variables];
;

useSearchQuestionsTotalCountQuery.fetcher = (variables: Types.SearchQuestionsTotalCountQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchQuestionsTotalCountQuery, Types.SearchQuestionsTotalCountQueryVariables>(SearchQuestionsTotalCountDocument, 'SearchQuestionsTotalCount', variables, options);